export default defineNuxtPlugin((nuxtApp) => {
    useHead({
        script: {
            src: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=P9e6fb',
            type: 'application/javascript',
            async: true
        }
    });
});
